/**
 * Hero Schema
 * Schema-driven settings for classic hero banner section
 */
export default {
  id: 'hero',
  version: 1,
  title: 'Hero: баннер',
  description: 'Классический hero-блок с фоновым изображением',
  icon: 'Image',
  category: 'hero',

  // Hero секции используют min-height, padding не применяется
  'x-styles': {
    paddingTop: 0,
    paddingBottom: 0
  },

  fields: [
    {
      group: 'Контент',
      fields: [
        {
          key: 'title',
          type: 'text',
          label: 'Заголовок',
          placeholder: 'Заголовок вашего сайта',
          defaults: { size: '5xl', weight: 'bold', color: 'white' }
        },
        {
          key: 'subtitle',
          type: 'text',
          label: 'Подзаголовок',
          placeholder: 'Краткое описание',
          multiline: true,
          rows: 2,
          defaults: { size: 'xl', weight: 'normal', color: 'white-muted' }
        }
      ]
    },
    {
      group: 'Фон',
      fields: [
        {
          key: 'backgroundImage',
          type: 'image',
          label: 'Фоновое изображение',
          hint: 'Рекомендуемый размер: 1920x1080'
        },
        {
          key: 'backgroundOverlay',
          type: 'range',
          label: 'Затемнение фона',
          min: 0,
          max: 100,
          step: 5,
          unit: '%',
          fromStorage: (v) => Math.round((v || 0.5) * 100),
          toStorage: (v) => v / 100
        }
      ]
    },
    {
      group: 'Оформление',
      fields: [
        {
          key: 'alignment',
          type: 'select',
          label: 'Выравнивание',
          options: [
            { value: 'left', icon: 'AlignLeft' },
            { value: 'center', icon: 'AlignCenter' },
            { value: 'right', icon: 'AlignRight' }
          ]
        },
        {
          key: 'height',
          type: 'select',
          label: 'Высота',
          mode: 'grid',
          columns: 2,
          options: [
            { value: 'small', label: 'Маленькая' },
            { value: 'medium', label: 'Средняя' },
            { value: 'large', label: 'Большая' },
            { value: 'fullscreen', label: 'На весь экран' }
          ]
        }
      ]
    },
    {
      group: 'Кнопки',
      fields: [
        {
          key: 'buttons',
          type: 'buttonList',
          label: 'Кнопки действий',
          variants: ['primary', 'outline']
        }
      ]
    }
  ],

  default: {
    title: { text: 'Заголовок вашего сайта' },
    subtitle: { text: 'Краткое описание или слоган для привлечения внимания посетителей' },
    backgroundImage: 'https://placehold.co/1920x1080/1a1a2e/ffffff?text=Hero',
    backgroundOverlay: 0.5,
    alignment: 'left',
    height: 'large',
    buttons: [
      { id: '1', text: 'Начать', variant: 'primary', link: '#' },
      { id: '2', text: 'Узнать больше', variant: 'outline', link: '#' }
    ]
  },

  migrate(data, fromVersion) {
    if (!fromVersion || fromVersion < 1) {
      const migrated = { ...this.default, ...data };
      ['title', 'subtitle'].forEach(key => {
        if (typeof migrated[key] === 'string') {
          migrated[key] = { text: migrated[key] };
        }
      });
      return migrated;
    }
    return data;
  }
};
